import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "triangle-right",
  "use": "triangle-right-usage",
  "viewBox": "0 0 32 30",
  "content": "<symbol viewBox=\"0 0 32 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"triangle-right\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.0029 17.2917C21.0204 16.4909 21.0204 14.9491 20.0029 14.1483L14.7155 9.98733C13.4035 8.9548 11.4787 9.88942 11.4787 11.559V19.881C11.4787 21.5506 13.4035 22.4852 14.7155 21.4527L20.0029 17.2917Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol